import SectionContainer from "../SectionContainer";
import Searchbar from "../Searchbar";

export default function TopContainerHeader(props) {
  const {
    sectionNameClass,
    sectionTitle,
    sectionDescription,
    hasSectionButton,
    hasSearch,
    hasSearchButton,
    addNewButtonClassName,
    name,
    btnType,
    href,
    searchClassName,
    searchPlaceholder,
    onButtonClick,
    searchData,
    onFilteredData,
    searchKeys,
    addFormModalOpen,
    addFormSetIsModalOpen,
    addFormModalShowLoader,
    payload,
    list,
    headers,
    formFields,
    successMessage,
    globalSearch,

    hasFilter,
    handleMonthRangeChange,
    handleDownloadMWERReport,
    listingStatus,
    expenseSelectedStatus,
    isDraftSelected,
    isGlSearch,
    onSearchValue,
    searchText,
    setSearchText,
    handleStatusChange,
    onSuccess,
    selectedRowKeys,
    deleteOnClick,
    publishDraftOnClick,
    currentPath
  } = props;
  
  return (
    <>
      <div className="commonTitle">
        <div className="container">
          <SectionContainer
            sectionNameClass={sectionNameClass}
            sectionTitle={sectionTitle}
            sectionDescription={sectionDescription}
            hasSectionButton={hasSectionButton}
            addNewButtonClassName={addNewButtonClassName}
            addNewButtonName={name}
            href={href}
            btnType={btnType}
            onButtonClick={onButtonClick}
            isVisible={addFormModalOpen}
            setIsVisible={addFormSetIsModalOpen}
            setShowLoader={addFormModalShowLoader}
          />
        </div>
      </div>
      {hasSearch && (
        <div className="commonSearch">
          <div className="container">            
            <Searchbar
              searchClassName={searchClassName}
              searchPlaceholder={searchPlaceholder}
              addNewButtonClassName={addNewButtonClassName}
              addNewButtonName={name}
              href={href}
              hasSearchButton={hasSearchButton}
              btnType={btnType}
              onButtonClick={onButtonClick}
              searchData={searchData}
              onFilteredData={onFilteredData}
              searchKeys={searchKeys}
              isVisible={addFormModalOpen}
              setIsVisible={addFormSetIsModalOpen}
              setShowLoader={addFormModalShowLoader}
              payload={payload}
              list={list}
              headers={headers}
              formFields={formFields}
              successMessage={successMessage}
              globalSearch={globalSearch}
              hasFilter={hasFilter}
              handleMonthRangeChange={handleMonthRangeChange}
              handleDownloadMWERReport={handleDownloadMWERReport}
              listingStatus={listingStatus}
              expenseSelectedStatus={expenseSelectedStatus}
              isGlSearch={isGlSearch}
              onSearchValue={onSearchValue}
              searchText={searchText}
              setSearchText={setSearchText}
              handleStatusChange={handleStatusChange}
              onSuccess={onSuccess}
              selectedRowKeys={selectedRowKeys}
              deleteOnClick={deleteOnClick}
              publishDraftOnClick={publishDraftOnClick}
              isDraftSelected={isDraftSelected}
              currentPath={currentPath}
            />
          </div>
        </div>
      )}
    </>
  );
}
